import { useEffect, useState, useCallback } from "react";
import { collection, query, where, getCountFromServer } from "firebase/firestore";
import { db } from "../services/firebase";

export const useUnreadCounts = () => {
  const [userFeedbackCount, setUserFeedbackCount] = useState(0);
  const [inquiriesCount, setInquiriesCount] = useState(0);
  const [topicRequestsCount, setTopicRequestsCount] = useState(0);
  const [evaluationReportCount, setEvaluationReportCount] = useState(0);
  const [loading, setLoading] = useState(true);

  const fetchUnreadCounts = useCallback(async () => {
    try {
      setLoading(true);

      // Firestore から直接未読件数を取得
      const [feedbackSnapshot, inquiriesSnapshot, topicRequestsSnapshot, evaluationReportSnapshot] =
        await Promise.all([
          getCountFromServer(
            query(collection(db, "customerFeedbacks"), where("status", "==", "pending"))
          ),
          getCountFromServer(
            query(collection(db, "customerInquiries"), where("status", "==", "pending"))
          ),
          getCountFromServer(
            query(collection(db, "customerTopicRequests"), where("status", "==", "pending"))
          ),
          getCountFromServer(
            query(collection(db, "customerEvaluationReports"), where("status", "==", "pending"))
          ),
        ]);

      setUserFeedbackCount(feedbackSnapshot.data().count);
      setInquiriesCount(inquiriesSnapshot.data().count);
      setTopicRequestsCount(topicRequestsSnapshot.data().count);
      setEvaluationReportCount(evaluationReportSnapshot.data().count);
    } catch (error) {
      console.error("Error fetching unread counts:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchUnreadCounts();
  }, [fetchUnreadCounts]);

  return {
    userFeedbackCount,
    inquiriesCount,
    topicRequestsCount,
    evaluationReportCount,
    totalCount: userFeedbackCount + inquiriesCount + topicRequestsCount + evaluationReportCount,
    loading,
    refetch: fetchUnreadCounts,
  };
};
